export default [
    //{ text : "Ivy (IA)", value : 1},
    //{ text : "Ivy (Old)", value : 2},
    
    { text : "Conversational", value : 1},
    { text : "No Conversational", value : 2},
    { text : "Worksheet", value : 3}
]